import React from "react";
import CommonCard from "components-v2/kpi/common-card";
import { useQuery } from "@tanstack/react-query";
import { apiRoot } from "services/src/config";
import { HOME_CARD_CONTENT } from "@/modules/home/constants";
import { ShimmerEffect } from "@/components/shimmer";

export default function BillingDelayCard({ onClick, cardData, tagId }) {
  const { data, isLoading } = useQuery({
    queryKey: ["am-on-time-billable-collection", tagId],
    queryFn: async () => {
      const endpoint = "/kpi/am-on-time-billable-collection";
      const response = await apiRoot.get(endpoint, {
        params: tagId ? { tagId } : undefined,
      });
      return response.data;
    },
  });

  const OnTimeBillable = Math.floor(data?.OnTimeBillableCollectionPercentage ?? 0);
  const delayedBillables = data?.delayedBillables ?? 0;
  const totalBillables = data?.totalBillables ?? 0;

  const { title, description } = HOME_CARD_CONTENT.billingDelay;

  return (
    <CommonCard
      title={title}
      info={description}
      onClick={onClick}
      cardData={{
        title: title,
        description: description,
        value: isLoading ? "0" : OnTimeBillable,
        unit: "%",
        details: [
          { label: "Delayed Billables", value: delayedBillables },
          { label: "Total Billables", value: totalBillables },
        ],
      }}
    >
      <div className="text-3xl font-bold mt-2">
        {isLoading ? <ShimmerEffect className="w-28 h-10" /> : <>{OnTimeBillable}%</>}
      </div>
    </CommonCard>
  );
}